import pick from 'lodash/pick';
import resolveStyle from './resolve-style';

export default function pickFromStyle(styles, properties) {
  return resolveStyle(Array.isArray(styles) ? styles : [styles])
    .reduce((acc, style) =>
      Object.assign(acc, pick(style, properties)), {});
}
